import React from 'react';
import cn from 'classnames';
import Button from '@creditflowresearch/uilib/Button';
import styles from './successOverlay.module.scss';

interface IProps {
  onCloseModalClick: () => void,
  successText: string,
  isSubmitSucceed: boolean,
}

const SuccessOverlay = (props: IProps) => {
  const isVisible = cn(styles.successOverlay, {
    [styles.succeedSubmit]: props.isSubmitSucceed,
  });
  return (
    <div className={ isVisible }>
      <div className={ styles.successSubmitContainer }>
        <div className={ styles.contentWrapper }>
          <h1>Thank you!</h1>
          <p>{ props.successText }</p>
          <Button
            variant="solid"
            color="primary"
            onClick={ props.onCloseModalClick }
            dataTest="closeModalButton"
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SuccessOverlay;
